'use strict';

import decoded from 'decoded';

export const moreCards = {
    13: { id: 13, section: 'more' },
    14: { id: 14, section: 'more' },
    16: { id: 16, section: 'more', target: 'twitter' },
    17: { id: 17, section: 'more' },
    18: { id: 18, section: 'more' },
    19: { id: 19, section: 'more' },
    20: { id: 20, section: 'more' }
}



// WEBPACK FOOTER //
// ./app/pages/more.js